import { ITypedReduxAction } from '../../types/redux';

export enum EHideOfferActionTypes {
  Request = 'hideOffer/request',
  Success = 'hideOffer/success',
  Failure = 'hideOffer/failure',
}

export interface IHideOfferSuccessPayload {
  offerId: number;
}

export type TRequestHideOffer = ITypedReduxAction<EHideOfferActionTypes.Request>;
export type TSuccessHideOffer = ITypedReduxAction<EHideOfferActionTypes.Success, IHideOfferSuccessPayload>;
export type TFailureHideOffer = ITypedReduxAction<EHideOfferActionTypes.Failure>;

export type THiddenObjectsActions = TRequestHideOffer | TSuccessHideOffer | TFailureHideOffer;
